@let arrowButtonClass =
  "absolute top-1/2 z-50 flex size-9 items-center justify-center -translate-y-1/2 rounded-[11px] bg-white desk:size-11 desk:rounded-[13px]";

<section class="h-[300px] pb-7 desk:h-[345px]">
  <div class="mask-curve-bottom relative flex h-full">
    <div class="hidden h-full flex-1 desk:block">
      <app-image [image]="data.store" [isPriority]="!isImageInPreviousBlocks" [pregenerationSize]="{ width: 1280 }" />
    </div>
    <div class="relative h-full flex-1 overflow-hidden">
      <div class="relative size-full">
        <div
          #slidesElementRef
          class="no-scrollbar flex size-full snap-x snap-mandatory overflow-x-scroll scroll-smooth">
          @for (image of sliderImages(); track $index) {
            @if (image) {
              @let hasUrl = !!image.url;
              <div
                (click)="image.url && openVirtualTour(image.url)"
                [ngClass]="{ 'cursor-pointer': !!image.url }"
                class="relative size-full flex-none snap-center">
                <app-image
                  [image]="image"
                  [isPriority]="!isImageInPreviousBlocks && $index === 0"
                  class="size-full object-cover" />
                @if (hasUrl) {
                  <div
                    class="absolute inset-0 flex flex-col items-center justify-center gap-y-1.5 bg-black/40 text-white">
                    <app-svg
                      [height]="24"
                      [inline]="true"
                      [width]="24"
                      class="text-white"
                      src="assets/icons/virtual-tour.svg" />
                    <div>{{ "COMPONENT.HERO-SLIDER.VIRTUAL_TOUR" | translate }}</div>
                  </div>
                }
              </div>
            }
          }
        </div>
        <div class="absolute bottom-2.5 left-2.5 z-10 flex justify-center">
          <app-button-middle-office type="EDIT_HERO" />
        </div>

        @if (sliderImagesCount() > 1) {
          <button
            (click)="moveSlider('prev')"
            [class]="arrowButtonClass"
            class="left-[3px] rotate-180 shadow-[-2px_-2px_0_0_#000] desk:left-6">
            <app-svg [width]="24" src="assets/icons/arrow-right.svg"></app-svg>
          </button>

          <button
            (click)="moveSlider('next')"
            [class]="arrowButtonClass"
            class="right-[3px] shadow-[2px_2px_0_0_#000] desk:right-6">
            <app-svg [width]="24" src="assets/icons/arrow-right.svg"></app-svg>
          </button>
        }
      </div>
    </div>
  </div>
</section>
